// extracted by mini-css-extract-plugin
module.exports = {"termsLink":"TermsAndConditions_termsLink__LJ3Fe","small":"TermsAndConditions_small__XYUcU","large":"TermsAndConditions_large__UJApX"};